import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/system';
import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import { alertActions, pricingDrawerUiActions } from '@actions';
import { useTranslation } from '@hooks';
import { ROLE } from '@constants/user';
import { RoutePath } from '@constants/routes';
import { ReactComponent as LockIcon } from 'assets/images/icons/lock.svg';

const Icon = styled(LockIcon)(({ variant }) => ({
    height: 14,
    transform: 'translateY(-1px)',
    marginRight: 4,
    ...(variant === 'contained' && {
        '& path': {
            fill: '#fff',
        },
    }),
    ...(variant === 'outlined' && {
        '& path': {
            fill: '#1F4C5C',
        },
    }),
    ...(variant === 'text' && {
        '& path': {
            fill: '#1F4C5C',
        },
    }),
}));

const LockedButton = ({ children, variant, className, drawerType, tooltipType }) => {
    const account = useSelector(state => state.account?.account);
    const user = useSelector(state => state.auth.user);

    const history = useHistory();

    const isSuperAdmin = user?.role === ROLE.SUPER_ADMIN;
    const isMultipleStripeAcc = account?.subscriptions.length > 1;

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleOpen = () => {
        if (isMultipleStripeAcc) {
            history.push(RoutePath.AccountSettingsGeneral);
            dispatch(alertActions.error(t('common.upgradeToAdd')));
        } else {
            dispatch(pricingDrawerUiActions.setOpen({ open: true, type: drawerType }));
        }
    };

    return (
        <Tooltip placement="top" title={tooltipType === 1 ? t('common.upgradeToAdd') : t('common.upgradeToUnlock')}>
            <span>
                <Button className={className} variant={variant} onClick={handleOpen} disabled={!isSuperAdmin}>
                    <Icon variant={variant} />
                    {children}
                </Button>
            </span>
        </Tooltip>
    );
};

export default LockedButton;
